export const messages = {
  tableOfContent: 'Table of content',
  backToTop: 'BACK TO TOP',
};
